
function SdOrderPricesCtrl(TranslationService, MaterialService, StoreService, ToastService, WorkflowService, AllocService, $uibModal) {
    var ctrl = this;

    ctrl.$onInit = function () {
        ctrl.additionals = [
            {
         
                "AdditionalID": 1,
                "AdditionalName": "Primer",
                "AdditionalValue": 150.0,
                "UnitID": "MBF",        
                "Name": "MBFAdditional"
            },
            {
                "AdditionalID": 2,
                "AdditionalName": "Barcode",
                "AdditionalValue": 25.0,
                "UnitID": "mbf",             
                "Name": "MBFAdditional"
            },
            {
                "AdditionalID": 3,
                "AdditionalName": "out of 6/4",
                "AdditionalValue": 50.0,
                "UnitID": "mbf",
                "Name": "MBFAdditional"
            },
            {
                "AdditionalID": 4,
                "AdditionalName": "3 out 5/4",
                "AdditionalValue": 50.0,
                "UnitID": "mbf",
                "Name": "MBFAdditional"
            },
            {
                "AdditionalID": 5,
                "AdditionalName": "from 4-7/8\" to 5-1/4",
                "AdditionalValue": 50.0,
                "UnitID": "mbf",
                "Name": "MBFAdditional"
            },
            {
                "AdditionalID": 6,
                "AdditionalName": "above 5-1/4 to 6-1/4",
                "AdditionalValue": 100.0,
                "UnitID": "mbf",
                "Name": "MBFAdditional"
            },
            {
                "AdditionalID": 7,
                "AdditionalName": "above 6-1/4 to 7-1/4",
                "AdditionalValue": 150.0,
                "UnitID": "mbf",
                "Name": "MBFAdditional"
            },
            {             
                "AdditionalID": 8,
                "AdditionalName": "above 7-1/4 to 8-1/4",
                "AdditionalValue": 200.0,
                "UnitID": "mbf",
                "Name": "MBFAdditional"
            },
            {
                "AdditionalID": 9,
                "AdditionalName": "stop/base caps",
                "AdditionalValue": 200.0,
                "UnitID": "mbf",
                "Name": "MBFAdditional"
            },
            {
                "AdditionalID": 10,
                "AdditionalName": "small mouldings",
                "AdditionalValue": 200.0,
                "UnitID": "mbf",
                "Name": "MBFAdditional"
            },
            {
                "AdditionalID": 11,
                "AdditionalName": "dado/pet",
                "AdditionalValue": 30.0,
                "UnitID": "mbf",
                "Name": "MBFAdditional"
            },
            {
                "AdditionalID": 12,
                "AdditionalName": "Miter/Pet",
                "AdditionalValue": 60.0,
                "UnitID": "mbf",
                "Name": "MBFAdditional"
            },
            {
                "AdditionalID": 13,
                "AdditionalName": "Stop/Miter/Pet",
                "AdditionalValue": 100.0,
                "UnitID": "mbf",
                "Name": "MBFAdditional"
            }
        ];
    }
}

SdOrderPricesCtrl.$inject = ['TranslationService', 'MaterialService', 'StoreService', 'ToastService', 'WorkflowService', 'AllocService', '$uibModal'];

seedWebApp.component('sdOrderPrices', {
    controller: SdOrderPricesCtrl,
    bindings: {
        loading: '<',
        order: '<',
        disabled: '<',
    },
    templateUrl: '/SPA/Orders/sd-order-prices.html'
});
